import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import { Get, handleError } from "../../../utils/fetch.util";
import i18next, { t } from "i18next";
import NoData from "../../../components/noData/noData.component";
import { useParams } from "react-router-dom";
import AddSatffDocumentModel from "../../../components/modals/AddSatffDocumentModel/AddSatffDocumentModel.component";
import { FiEdit } from "react-icons/fi";

const StaffDocuments = () => {
  const { staffId } = useParams();
  const [staffDocuments, setSatffDocuments] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getValidToken } = useContext(UserContext);
  const [openAddStaffDocument, setOpenAddStaffDocument] =
    useState<boolean>(false);
  const [staffDocumentId, setStaffdocumentId] = useState<number>(0);
  const [editStaffDocument, setEditStaffDocument] = useState<any>(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [staffDocumentsCount, setStaffDocumentsCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const getAllStaffDocuments = async () => {
    setIsLoading(true);
    const res = await Get(
      `staff-documents/get-staff-documents?staff_id=${staffId}`,
      getValidToken(),
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    setSatffDocuments(res.data);
    setStaffDocumentsCount(res.count);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllStaffDocuments();
  }, [page]);

  return (
    <>
      <div className="container bg-white p-6 px-8">
        <div className="flex items-center justify-between my-5">
          <h1 className="text-5xl">
            {t("staff_documents")}{" "}
            <span className="text-2xl">({staffDocuments?.length})</span>
          </h1>
          <button
            className="main_btn"
            onClick={() => setOpenAddStaffDocument(true)}
          >
            {t("add_staff_document")}
          </button>
        </div>

        {staffDocuments?.length === 0 ? (
          <div className="flex justify-center items-center h-[500px]">
            <NoData message={t("no_staff_documents")} />
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full mt-5 mb-5">
              <thead className="w-full">
                <tr className="border-collapse border-2 w-full">
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("image")}
                  </th>
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("title")}
                  </th>
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("description")}
                  </th>
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("actions")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="h-6">
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                </tr>
                {staffDocuments.map((document, i) => {
                  return (
                    <tr>
                      <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                        <img
                          src={`${import.meta.env.VITE_API_URL}/${
                            document.image_url
                          }`}
                          alt="room-img"
                          className="h-[70px] w-[70px] rounded-full object-cover"
                          loading="lazy"
                        />
                      </td>
                      <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                        {document.title}
                      </td>
                      <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                        {document.description.length > 50
                          ? document.description.slice(0, 50) + "..."
                          : document.description}
                      </td>
                      <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                        <div className="flex gap-2">
                          <div
                            className=""
                            onClick={() => {
                              setEditStaffDocument(document);
                              setOpenAddStaffDocument(true);
                            }}
                          >
                            <FiEdit className="text-xl text-text cursor-pointer" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {openAddStaffDocument && (
        <AddSatffDocumentModel
          open={openAddStaffDocument}
          setOpen={setOpenAddStaffDocument}
          getAllItems={getAllStaffDocuments}
          editStaffDocument={editStaffDocument}
          setEditStaffDocument={setEditStaffDocument}
        />
      )}
    </>
  );
};

export default StaffDocuments;
